import { useEffect, useState } from "react";
import { DescTremor, Tit2Tremor } from "../comps/coolComp";
import { RColumn, RRow, Space } from "../comps/otherCOmps";
import { Badge, Card } from "@tremor/react";
import { getLastChatGames } from "./dao";

export default function LatestBetsChatGames() {
  const [lastGames, setLastGames] = useState([]);

  useEffect(() => {
    getLastChatGames(30).then((p) => setLastGames(p));
  }, []);
  return (
    <>
      <Tit2Tremor>Last bets</Tit2Tremor>
      <Space />
      {lastGames.map((g, i) => (
        <Card key={g.id + i} className="mb-3">
          <dt className="text-tremor-default font-medium text-tremor-content dark:text-dark-tremor-content">
            {g.timestamp.substring(0, 19).replace("T", " ")}
          </dt>
          <RRow width={"100%"} horizontalAlign="space-between">
            <dt className="text-tremor-default font-medium dark:text-dark-tremor-content">
              {g.game_type}
            </dt>
            <RRow>
              <Badge>{g.status}</Badge>
              <Badge>{g.result}</Badge>
            </RRow>
          </RRow>
          <Space height="6px" />
          <RRow>
            <p className="text-tremor-default font-medium text-tremor-content dark:text-dark-tremor-content">
              Amount per usr: {parseFloat(g.amount_per_user).toFixed(2)}{" "}
              {g.currency.toUpperCase()}
            </p>
            <p className="text-tremor-default font-medium text-tremor-content dark:text-dark-tremor-content">
              Total payout: {parseFloat(g.total_payout).toFixed(2)}{" "}
              {g.currency.toUpperCase()}
            </p>
          </RRow>
          <Space height="6px" />
          <RRow horizontalAlign="space-between">
            <RColumn horizontalAlign="start">
              <Tit2Tremor>Players</Tit2Tremor>
              {g.users.map((u) => (
                <DescTremor key={u + "p"}>{u}</DescTremor>
              ))}
            </RColumn>
            <RColumn horizontalAlign="start">
              <Tit2Tremor>Winners</Tit2Tremor>
              {g.winners.map((u) => (
                <DescTremor key={u + "w"}>{u}</DescTremor>
              ))}
            </RColumn>
          </RRow>
        </Card>
      ))}
    </>
  );
}
